import { BarcodeGlyph } from '@components/shelfDetails/ShelfLikeViewShelf'
import useTypedTranslation from '@hooks/useTypedTranslation.ts'
import { useStockLevelMapper } from '@utils/stockLevelMapper.ts'

function ShelfLegend({ showFacingStates = false }: { showFacingStates?: boolean }) {
  const { t } = useTypedTranslation()
  const { isHidingUnknown } = useStockLevelMapper()

  return (
    <ul className='flex flex-wrap gap-x-5 gap-y-1 px-6' data-testid="shelf-legend">
      <li className='flex items-center gap-2'>
        <div className='size-3 rounded-full bg-no-stock'/>
        <p className='text-sm font-medium'>{t('common.outOfStock')}</p>
      </li>

      {!isHidingUnknown && (
        <li className='flex items-center gap-2'>
          <div className='size-3 rounded-full bg-unknown-stock'/>
          <p className='text-sm font-medium'>{t('common.unknownStock')}</p>
        </li>
      )}

      {showFacingStates && (<>
        <li className='flex items-center gap-2'>
          <div className='flex h-3.5 w-3 items-end justify-center rounded-t-xs bg-utility-gray-400'>
            <BarcodeGlyph className='mb-0.5 w-2 text-utility-gray-50' />
          </div>
          <p className='text-sm font-medium'>{t('storeMap.shelf.facingState.noImage')}</p>
        </li>
        <li className='flex items-center gap-2'>
          <div className={`
            flex h-3.5 w-3 items-center justify-center rounded-xs border border-dashed border-utility-gray-600
            text-[9px] font-bold text-utility-gray-600
          `}>?</div>
          <p className='text-sm font-medium'>{t('storeMap.shelf.facingState.noGtin')}</p>
        </li>
      </>)}
    </ul>
  )
}

export default ShelfLegend

